export const SHOW_REQUEST_AVAILABLE_BROADCAST_MODAL =
  "SHOW_REQUEST_AVAILABLE_BROADCAST_MODAL";
export const HIDE_REQUEST_AVAILABLE_BROADCAST_MODAL =
  "HIDE_REQUEST_AVAILABLE_BROADCAST_MODAL";

export const SHOW_AWAITING_MODAL = "SHOW_AWAITING_MODAL";
export const HIDE_AWAITING_MODAL = "HIDE_AWAITING_MODAL";

export const SHOW_COMMON_CONFIRMATION_MODAL = "SHOW_COMMON_CONFIRMATION_MODAL";
export const HIDE_COMMON_CONFIRMATION_MODAL = "HIDE_COMMON_CONFIRMATION_MODAL";

// Tip modal from viewer side
export const SHOW_TIP_MODAL = "SHOW_TIP_MODAL";
export const HIDE_TIP_MODAL = "HIDE_TIP_MODAL";

export const SHOW_TIP_RESPONSE_MODAL = "SHOW_TIP_RESPONSE_MODAL";
export const HIDE_TIP_RESPONSE_MODAL = "HIDE_TIP_RESPONSE_MODAL";

// Tip modal from broadcaster side
export const SHOW_TIP_LIST_MODAL = "SHOW_TIP_LIST_MODAL";
export const HIDE_TIP_LIST_MODAL = "HIDE_TIP_LIST_MODAL";

export const SHOW_COMMON_MODAL = "SHOW_COMMON_MODAL";
export const HIDE_COMMON_MODAL = "HIDE_COMMON_MODAL";

export const SHOW_BROADCASTER_VIDEO_PLAYER_MODAL = "SHOW_BROADCASTER_VIDEO_PLAYER_MODAL";
export const HIDE_BROADCASTER_VIDEO_PLAYER_MODAL = "HIDE_BROADCASTER_VIDEO_PLAYER_MODAL";